import type {
  UserProfile,
  UpdatePreferencesDto,
  UserPreferences,
} from '@reqshare/shared';

const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:3000';

async function request<T>(
  path: string,
  options: RequestInit = {},
  token?: string,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string>) ?? {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({
      message: response.statusText,
    }));
    throw new Error(error.message || `Request failed with status ${response.status}`);
  }

  return response.json();
}

export function getGoogleAuthUrl(options?: {
  source?: string;
  extensionId?: string;
}): string {
  const params = new URLSearchParams();
  if (options?.source) params.set('source', options.source);
  if (options?.extensionId) params.set('extensionId', options.extensionId);
  const qs = params.toString();
  return `${API_BASE}/auth/google${qs ? `?${qs}` : ''}`;
}

export function getGithubAuthUrl(options?: {
  source?: string;
  extensionId?: string;
}): string {
  const params = new URLSearchParams();
  if (options?.source) params.set('source', options.source);
  if (options?.extensionId) params.set('extensionId', options.extensionId);
  const qs = params.toString();
  return `${API_BASE}/auth/github${qs ? `?${qs}` : ''}`;
}

export function getProfile(token: string): Promise<UserProfile> {
  return request('/users/me', { method: 'GET' }, token);
}

export function updatePreferences(
  dto: UpdatePreferencesDto,
  token: string,
): Promise<UserPreferences> {
  return request(
    '/users/me/preferences',
    { method: 'PATCH', body: JSON.stringify(dto) },
    token,
  );
}
